import './styles.scss'

import React, { useEffect, useState } from 'react'
import { FormFeedback } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import _cloneDeep from 'lodash.clonedeep'
import _set from 'lodash.set'
import _get from 'lodash.get'

import { company as companyApi } from 'api'
import renderField from './fields/renderField'
import Buttons from './fields/Buttons'
import PhoneViewer from 'components/PhoneViewer'
import { isValidHttpsUrl } from 'utils/helpers'
import { notRenderSendConnectionAPIToken } from 'views/Dashboard/Configurations/ChannelsConfigurations/ChannelGroup/SendConnectionAPIToken'

const CHANNELS = ['instagram', 'facebook', 'chatmail', 'whatsapp', 'telegram']
const { channels: channelsApi } = companyApi

const validateChannel = (schema, channel, setErrors) => {
  const errors = {}
  const elements = Object.values(schema.schema)

  for (let elem of elements) {
    if (elem.required && !_get(channel, elem.prop)) {
      errors[elem.prop] = true
    }
    if (elem.prop === 'value.whitelist') {
      const isValid = isValidHttpsUrl(channel.value.whitelist)
      if (!isValid)
        errors[`${elem.prop}_chatweb_domain`] = true
    }
    if (elem.prop === 'value.webSite') {
      const isValid = isValidHttpsUrl(channel.value.webSite)
      if (!isValid)
        errors[`${elem.prop}_app_domain`] = true
    }
    if (elem.prop === 'value.authenticationType') {
      if ((_get(channel, elem.prop) === 'sms' || _get(channel, elem.prop) === 'email') && !_get(channel, 'value.smsAuthenticationId')) {
        errors[elem.prop] = true
        // THIS LOGIC IS NECESARY FOR MOVE DE ERROR FIELD BELOW THE LAST REQUIRED FIELD
        // AND BEFORE THE DIAL CODE FOR SMS
        const container = document.getElementById('container_value.authenticationType')
        const elements = container.children
        if (container && elements.length > 0) {
          const errorField = document.getElementById('field_error_value.authenticationType')
          if (errorField) {
            if (_get(channel, elem.prop) === 'sms') {
              const reference = document.getElementById('channels_sms_dial_code_value.authenticationType')
              container.insertBefore(errorField, reference)
            } else if (_get(channel, elem.prop) === 'email') {
              container.appendChild(errorField)
            }
          }
        }
      }
    }
    if (elem.prop === 'value.authMsg' || elem.prop === 'value.authOkMsg') {
      if (_get(channel, 'value.authenticationType') === 'none' || _get(channel, 'value.authenticationType') === 'redirectFromChannel') {
        delete errors[elem.prop]
      } else {
        if (!_get(channel, elem.prop)?.content && (!_get(channel, elem.prop)?.contentHtml || _get(channel, elem.prop)?.contentHtml === '<p><br></p>'))
          errors[elem.prop] = true
      }
    }
  }

  setErrors(errors)

  if (Object.keys(errors).length) return false
  return true
}

function addDefaultValues(schema, channel) {
  const elements = Object.values(schema.schema)

  for (const elem of elements) {
    const { defaultValue, prop, field } = elem

    if (defaultValue !== undefined && _get(channel, prop) === undefined) {
      if (field === 'richText') {
        _set(channel, `${prop}.content`, I18n.t(defaultValue))
        _set(channel, `${prop}.contentHtml`, I18n.t(defaultValue))
      }
      else {
        const value = typeof defaultValue === 'string'
          ? I18n.t(defaultValue)
          : defaultValue

        _set(channel, prop, value)
      }
    }
  }

  return channel
}

function checkHiddenField(channel, input, operatorRole) {
  if (
    input.prop === 'sendAPIToken' &&
    notRenderSendConnectionAPIToken(input, channel, operatorRole)
  ) return true

  return false
}

/**
 * Channel tab Panel
 * @param {object} props
 * @param {string} props.activeTab
 * @param {object} props.schema
 * @param {object} props.company
 * @param {object} props.currentChannel
 * @param {function} props.onOpenForm
 * @param {object} props.brandAndDelegation
 * @param {function} props.onNeedBrandAndDelegation display error by delegation is need
 * @param {function} props.onUpdateChannel
 * @param {function} props.onRemoveChannel
 */
const FormChannel = (props) => {
  const {
    schema,
    company,
    currentChannel,
    brandAndDelegation,
    onNeedBrandAndDelegation,
    onUpdateChannel,
    type,
    onCancel,
    isOpenContainer,
    onOTPVerification
  } = props

  const operatorSessionRole = useSelector(store => store.user.role)
  const [errors, setErrors] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [submitOptions, setSubmitOptions] = useState({})
  const [channel, setChannel] = useState(currentChannel || {})
  const [SMSChannels] = React.useState([])

  useEffect(() => {
    setChannel({ ...channel, brandDefault: brandAndDelegation.brand, delegationDefault: brandAndDelegation.delegation })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandAndDelegation])

  useEffect(() => {
    setChannel(currentChannel)
    setSubmitOptions({})
    setErrors({})
    setDisabled(false)
  }, [currentChannel])

  /**
   * Update channel fields and values
   * @param {string} field field to update in object
   * @param {*} value value to set
   * @param {Object} options
   * @param {boolean} [options.submit=false] auto submit
   * @param {object} [options.submitOptions] options for submit
   */
  const onChange = (field, value, options = {}) => {
    const { submit = false } = options

    _set(channel, field, value)

    if (field === 'value.authenticationType' && value !== 'sms') {
      _set(channel, 'value.smsAuthenticationId', '')
    }
    if (field === 'value.connectionType' && (value !== 'android_api' || value !== 'ios_api')) {
      _set(channel, 'value.url', '')
    }
    if (field === 'value.authenticationType' && _get(channel, 'isNew')) {
      if (value === 'only_phone' || value === 'sms') {
        let hasValue = _get(channel, 'value.authMsg')?.content && (_get(channel, 'value.authMsg')?.contentHtml || _get(channel, 'value.authMsg')?.contentHtml === '<p><br></p>')
        if (!hasValue) {
          _set(channel, 'value.authMsg.content', I18n.t('credentials_authMsg_default_phone'))
          _set(channel, 'value.authMsg.contentHtml', I18n.t('credentials_authMsg_default_phone'))
        }
      } else if (value === 'only_email' || value === 'email') {
        let hasValue = _get(channel, 'value.authMsg')?.content && (_get(channel, 'value.authMsg')?.contentHtml || _get(channel, 'value.authMsg')?.contentHtml === '<p><br></p>')
        if (!hasValue) {
          _set(channel, 'value.authMsg.content', I18n.t('credentials_authMsg_default_email'))
          _set(channel, 'value.authMsg.contentHtml', I18n.t('credentials_authMsg_default_email'))
        }
      }
    }
    setChannel({ ...channel })
    
    if (submit) {
      // only for facebook channels
      setSubmitOptions(options.submitOptions || {})

      if (channel.isNew) {
        onSubmit(options.submitOptions || {})
      }
    }
  }

  /**
   * Submit
   * @param {object} options
   * @param {boolean} options.permissions // Update permissions for some channels
   */
  const onSubmit = async (options) => {
    setDisabled(true)

    const { permissions = false } = options || submitOptions

    const channelData = addDefaultValues(schema, _cloneDeep(channel))

    if (channelData.key === 'android' || channelData.key === 'ios') {
      _set(channelData, 'app.language', 'es_ES')
    }

    if (brandAndDelegation.brand && !brandAndDelegation.delegation) {
      setDisabled(false)
      onNeedBrandAndDelegation(true)
      return
    }

    const validate = validateChannel(schema, channelData, setErrors)
    if (!validate) {
      setDisabled(false)
      return
    }

    let msg = ''
    let isOK = null

    try {
      if (channelData.isNew) {
        if(channelData.key === 'chatweb' && !channelData.value.withUrlVisited)
          channelData.value.withUrlVisited = false

        if (CHANNELS.includes(channelData.hub)) {
          const { data } = await channelsApi.postChannelNew({ ...channelData, _id: undefined })
          onUpdateChannel(data)
          msg = 'dashboard_channel-created'
          isOK = data
        }
        else {
          const { data } = await channelsApi.postChannel(company._id, { ...channelData, _id: undefined }, channelData.key)
          onUpdateChannel(data.results)
          msg = 'dashboard_channel-created'
        }
      } else {
        if (CHANNELS.includes(channelData.hub)) {
          const { data } = await channelsApi.updateChannelNew(channelData._id, { credential: { ...channelData }, permissions })
          onUpdateChannel(data)
          msg = 'dashboard_updated-channel'
          isOK = data
        }
        else {
          const { data } = await channelsApi.updateChannel(company._id, { credential: { ...channelData }, permissions }, channelData.key)
          onUpdateChannel(data.results)
          msg = 'dashboard_updated-channel'
        }

        setSubmitOptions({})
      }
    } catch ({ response = {}, message }) {
      const { data = {} } = response

      msg = data?.message?.errorMessage ? data.message.errorMessage : data.type || 'toasts_generic_error'
    }
    toast(I18n.t(msg), { position: 'top-center' })
    onNeedBrandAndDelegation(false)
    setDisabled(false)

    if (channelData.hub === 'chatmail') {
      return new Promise((resolve, reject) => {
        return resolve(isOK)
      })
    }
  }

  const filterSchema = (schema, allowed) => {
    return Object.keys(schema)
      .filter(key => allowed.includes(key))
      .reduce((newSchema, key) => {
        newSchema[key] = schema[key]
        return newSchema
      }, {})
  }

  return (
    <div className='form-channel'>
      {Object.values(filterSchema(schema.schema, _get(schema, `containers.${type}`))).map((input, index) => {
        // SHOW DEEPLINK FOR IOS/ANDROID API
        if (channel.key === 'wall' && input.propName === 'value_url') {
          if (channel.value.connectionType === 'android_api' || channel.value.connectionType === 'ios_api')
            input['hidden'] = false
          else
            input['hidden'] = true
        }
        if (input.hidden) return null
        input.propName = input.prop.replace(/\./g, '_')

        // SETEA CANELES SMS PARA CHATWEB
        if (channel.hub === 'wall') {
          input['options2'] = SMSChannels
            .filter(elem => elem.key === 'sms')
            .map((elem, index) => ({ label: elem.value.botId, value: elem._id }))
          input['smsAuthenticationId'] = channel.value.smsAuthenticationId
        }

        const renderItem = renderField({
          configInput: input,
          channel: channel,
          disabled: disabled,
          onChangeChannel: onChange,
          error: errors[input.prop],
          company: company,
          isOpenContainer,
          onSubmit: onSubmit,
          schema: schema,
          onOTPVerification
        })

        if (!renderItem || checkHiddenField(channel, input, operatorSessionRole)) return null

        return (
          <div key={index}>
            {renderItem}

            <FormFeedback id={`field_error_${input.prop}`} className={`invalid-feedback-channels ${input.prop}`}>
              {
                errors[input.prop] ? I18n.t('dashboard_errors_required-field')
                  : errors[`${input.prop}_chatweb_domain`] ? I18n.t('error_fields_one_domain')
                    : errors[`${input.prop}_app_domain`] ? I18n.t('error_fields_valid_domain')
                      : ''
              }
            </FormFeedback>
          </div>
        )
      })}
      <Buttons onSave={onSubmit} onCancel={onCancel} isSubmitting={disabled} />
      <FormFeedback className='invalid-feedback-channels'>
        {
          Object.values(errors).length ? I18n.t('dashboard_all-required-field') : ''
        }
      </FormFeedback>
      {isOpenContainer.resources && (
        <div className='app-preview'>
          <div className='app-preview__wrapper'>
            <PhoneViewer
              channel={schema.key}
              textPreview={{ channelAppPreview: true }}
              primaryColor={channel.value.primaryColor}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default FormChannel
